(function () {
  'use strict';

  var STOREFRONT_API = 'https://mnxkcb-0p.myshopify.com/api/2024-01/graphql.json';
  var STOREFRONT_TOKEN = '1b566218d7c489a787a44c1d587b5e78';
  var ACCOUNT_URL = '/pages/my-account';
  var LOGIN_URL = '/pages/login-with-whatsapp';
  var CACHE_KEY = 'rga_cust';
  var CACHE_TTL = 10 * 60 * 1000; // 10 min

  function getCookie(n) {
    var m = document.cookie.match(new RegExp('(^| )' + n + '=([^;]+)'));
    return m ? decodeURIComponent(m[2]) : null;
  }

  function getToken() {
    return getCookie('wa_customer_token');
  }

  // ===== Cached customer fetch (avoids API call on every page load) =====
  async function getCustomer() {
    var token = getToken();
    if (!token) return null;

    // Check sessionStorage cache
    try {
      var cached = sessionStorage.getItem(CACHE_KEY);
      if (cached) {
        var parsed = JSON.parse(cached);
        if (parsed.token === token && Date.now() - parsed.ts < CACHE_TTL) {
          return parsed.data;
        }
      }
    } catch (e) {}

    // Fetch from API
    try {
      var q = 'query c($t:String!){customer(customerAccessToken:$t){firstName lastName email phone defaultAddress{firstName lastName address1 address2 city province provinceCode zip country countryCodeV2 phone}}}';
      var res = await fetch(STOREFRONT_API, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN
        },
        body: JSON.stringify({ query: q, variables: { t: token } })
      });
      var json = await res.json();
      var cust = json && json.data ? json.data.customer : null;

      if (cust) {
        try {
          sessionStorage.setItem(CACHE_KEY, JSON.stringify({
            token: token,
            ts: Date.now(),
            data: cust
          }));
        } catch (e) {}
      }
      return cust;
    } catch (e) {
      return null;
    }
  }

  // ===== HEADER: swap account icon + links =====
  async function patchHeader() {
    var token = getToken();
    var cust = token ? await getCustomer() : null;
    var loggedIn = !!(token && cust);

    var initial = loggedIn ? (cust.firstName || 'U').charAt(0).toUpperCase() : '';
    var displayName = loggedIn ? ([cust.firstName, cust.lastName].filter(Boolean).join(' ') || 'Account') : '';

    // ── Patch ALL /account links on the page ──
    document.querySelectorAll('a[href*="/account"]').forEach(function (link) {
      if (link.closest('#rga_root') || link.closest('.rg-auth')) return;
      var href = link.getAttribute('href') || '';

      if (href.indexOf('/account/login') !== -1 || href.indexOf('/account/register') !== -1) {
        link.setAttribute('href', loggedIn ? ACCOUNT_URL : LOGIN_URL);
      } else if (href.indexOf('/account') !== -1) {
        link.setAttribute('href', loggedIn ? ACCOUNT_URL : LOGIN_URL);
      }
    });

    // ── Desktop account icon — swap SVG for avatar if logged in ──
    if (loggedIn) {
      var desktopIcons = document.querySelectorAll('a.header__icon[aria-label]');
      desktopIcons.forEach(function (link) {
        var href = link.getAttribute('href') || '';
        if (href.indexOf('/account') === -1 && href.indexOf(ACCOUNT_URL) === -1 && href.indexOf(LOGIN_URL) === -1) return;

        link.setAttribute('href', ACCOUNT_URL);
        link.setAttribute('aria-label', displayName);
        link.innerHTML =
          '<span style="' +
            'display:inline-flex;align-items:center;justify-content:center;' +
            'width:32px;height:32px;border-radius:50%;' +
            'background:linear-gradient(135deg,#2B7EC1,#225f92);' +
            'color:#fff;font-size:13px;font-weight:700;line-height:1;' +
            'box-shadow:0 2px 8px -2px rgba(43,126,193,.5);' +
            'letter-spacing:0;' +
          '">' + initial + '</span>';
      });
    }

    // ── Mobile menu bottom buttons ──
    // The mobile drawer is inside a <template> tag, so it may not be in the DOM yet.
    // We use a MutationObserver to catch it when it gets injected.
    patchMobileMenu(loggedIn, cust);
    var observer = new MutationObserver(function () {
      patchMobileMenu(loggedIn, cust);
    });
    observer.observe(document.body, { childList: true, subtree: true });
    // Stop observing after 10 seconds to avoid performance impact
    setTimeout(function () { observer.disconnect(); }, 10000);
  }

  function patchMobileMenu(loggedIn, cust) {
    var mobileLinks = document.querySelectorAll('.header-menu-bottom a');
    if (!mobileLinks.length) return;

    mobileLinks.forEach(function (link) {
      if (link.getAttribute('data-rga-patched')) return; // don't double-patch
      link.setAttribute('data-rga-patched', '1');

      var href = link.getAttribute('href') || '';

      if (loggedIn) {
        if (href.indexOf('/account/login') !== -1 || (href.indexOf('/account') !== -1 && href.indexOf('/account/register') === -1 && href.indexOf('/account/logout') === -1)) {
          link.setAttribute('href', ACCOUNT_URL);
          link.textContent = 'My Account';
        }
        if (href.indexOf('/account/register') !== -1) {
          link.textContent = 'Sign Out';
          link.setAttribute('href', '#');
          link.addEventListener('click', function (e) {
            e.preventDefault();
            document.cookie = 'wa_customer_token=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC; samesite=lax';
            document.cookie = 'wa_customer_email=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC; samesite=lax';
            sessionStorage.removeItem(CACHE_KEY);
            window.location.href = LOGIN_URL;
          });
        }
      } else {
        if (href.indexOf('/account/login') !== -1) {
          link.setAttribute('href', LOGIN_URL);
        }
        if (href.indexOf('/account/register') !== -1) {
          link.setAttribute('href', LOGIN_URL);
          link.textContent = 'Sign in';
        }
      }
    });
  }

  // ===== CHECKOUT PREFILL: intercept checkout navigation =====
  function setupCheckoutPrefill() {
    var token = getToken();
    if (!token) return;

    // Listen for clicks on any element that leads to checkout
    document.addEventListener('click', function (e) {
      var link = e.target.closest('a[href*="/checkout"], button[name="checkout"], input[name="checkout"], [data-shopify-checkout]');
      if (!link) return;

      // Only intercept actual navigation links
      var href = '';
      if (link.tagName === 'A') {
        href = link.getAttribute('href') || '';
        if (href.indexOf('/checkout') === -1 && href.indexOf('/cart') === -1) return;
      }

      // For form submit buttons, we handle via the form submit event below
      if (link.tagName === 'BUTTON' || link.tagName === 'INPUT') return;

      // Prevent default navigation
      e.preventDefault();
      redirectToCheckoutWithPrefill(href);
    }, true);

    // Listen for form submissions to /checkout
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form) return;
      var action = form.getAttribute('action') || '';

      // Cart form submitting to /cart or /checkout
      var hasCheckoutBtn = form.querySelector('[name="checkout"], [type="submit"][value*="Check"]');
      if (action.indexOf('/cart') !== -1 && hasCheckoutBtn) {
        // Check if the submit was triggered by a checkout button
        var submitter = e.submitter;
        if (submitter && (submitter.name === 'checkout' || (submitter.value && submitter.value.toLowerCase().indexOf('check') !== -1))) {
          e.preventDefault();
          redirectToCheckoutWithPrefill('/checkout');
          return;
        }
      }

      if (action.indexOf('/checkout') !== -1) {
        e.preventDefault();
        redirectToCheckoutWithPrefill(action);
      }
    }, true);
  }

  async function redirectToCheckoutWithPrefill(baseUrl) {
    var cust = await getCustomer();

    var params = [];

    // EMAIL: Use cookie as primary source (always fresh after profile save)
    // Storefront API caches aggressively and may return stale temporary email
    var emailFromCookie = getCookie('wa_customer_email');
    var email = emailFromCookie || (cust ? cust.email : '');
    // Skip temporary auto-generated emails
    if (email && !/^wa_\d+@/.test(email)) {
      params.push('checkout[email]=' + encodeURIComponent(email));
    }

    if (cust) {
      var addr = cust.defaultAddress;
      if (addr) {
        if (addr.firstName) params.push('checkout[shipping_address][first_name]=' + encodeURIComponent(addr.firstName));
        if (addr.lastName) params.push('checkout[shipping_address][last_name]=' + encodeURIComponent(addr.lastName));
        if (addr.address1) params.push('checkout[shipping_address][address1]=' + encodeURIComponent(addr.address1));
        if (addr.address2) params.push('checkout[shipping_address][address2]=' + encodeURIComponent(addr.address2));
        if (addr.city) params.push('checkout[shipping_address][city]=' + encodeURIComponent(addr.city));
        if (addr.province) params.push('checkout[shipping_address][province]=' + encodeURIComponent(addr.province));
        if (addr.zip) params.push('checkout[shipping_address][zip]=' + encodeURIComponent(addr.zip));
        if (addr.countryCodeV2) params.push('checkout[shipping_address][country]=' + encodeURIComponent(addr.countryCodeV2));
        if (addr.phone) params.push('checkout[shipping_address][phone]=' + encodeURIComponent(addr.phone));
      } else {
        if (cust.firstName) params.push('checkout[shipping_address][first_name]=' + encodeURIComponent(cust.firstName));
        if (cust.lastName) params.push('checkout[shipping_address][last_name]=' + encodeURIComponent(cust.lastName));
        if (cust.phone) params.push('checkout[shipping_address][phone]=' + encodeURIComponent(cust.phone));
      }
    }

    if (params.length === 0) {
      window.location.href = baseUrl || '/checkout';
      return;
    }

    try {
      var cartRes = await fetch('/cart.json');
      var cartData = await cartRes.json();
      var items = cartData && cartData.items;

      if (!items || items.length === 0) {
        window.location.href = baseUrl || '/checkout';
        return;
      }

      var cartParts = items.map(function (item) {
        return item.variant_id + ':' + item.quantity;
      }).join(',');

      window.location.href = '/cart/' + cartParts + '?' + params.join('&');

    } catch (e) {
      window.location.href = baseUrl || '/checkout';
    }
  }

  // ===== GLOBAL CLICK INTERCEPTOR =====
  // Catches ALL clicks to Shopify login/register/account URLs anywhere on the page.
  // Covers both legacy (/account/login) and new customer accounts (shopify.com/authentication).
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href]');
    if (!link) return;

    // Don't intercept links inside our own pages
    if (link.closest('#rga_root') || link.closest('.rg-auth') || link.closest('#rga_addrModal')) return;

    var href = link.getAttribute('href') || '';

    // All patterns that indicate a Shopify login/register/account link
    var isAccountLink =
      href.indexOf('/account/login') !== -1 ||
      href.indexOf('/account/register') !== -1 ||
      href.indexOf('shopify.com/authentication') !== -1 ||
      href.indexOf('/customer/') !== -1 ||
      (href.match(/\/account\/?$/) !== null);

    if (isAccountLink) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      var token = getToken();
      window.location.href = token ? ACCOUNT_URL : LOGIN_URL;
      return false;
    }
  }, true); // Capture phase — runs before theme handlers
  // ===== INIT =====
  function init() {
    patchHeader();
    setupCheckoutPrefill();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();